module.exports = __webpack_public_path__ + "static/media/robot-waiting.bdb2e4b8.svg";